import { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import {
    User,
    Dumbbell,
    Users,
    Star,
    Shield,
    ChevronDown,
    Check
} from 'lucide-react';

const roleConfig = {
    personal: {
        label: 'Personal Trainer',
        icon: Dumbbell,
        color: 'from-purple-500 to-purple-700',
        bgLight: 'bg-purple-50',
        textColor: 'text-purple-700',
    },
    student: {
        label: 'Atleta',
        icon: Users,
        color: 'from-blue-500 to-blue-700',
        bgLight: 'bg-blue-50',
        textColor: 'text-blue-700',
    },
    influencer: {
        label: 'Afiliado',
        icon: Star,
        color: 'from-pink-500 to-pink-700',
        bgLight: 'bg-pink-50',
        textColor: 'text-pink-700',
    },
    admin: {
        label: 'Administrador',
        icon: Shield,
        color: 'from-gray-700 to-gray-900',
        bgLight: 'bg-gray-100',
        textColor: 'text-gray-700',
    },
};

export function ProfileSwitcher() {
    const { profiles, activeRole, switchRole, hasMultipleProfiles, profile } = useAuth();
    const [isOpen, setIsOpen] = useState(false);

    if (!hasMultipleProfiles || !activeRole) {
        return null;
    }

    const currentConfig = roleConfig[activeRole] || roleConfig.personal;
    const CurrentIcon = currentConfig.icon;

    return (
        <div className="relative">
            <button
                onClick={() => setIsOpen(!isOpen)}
                className={`flex items-center gap-2 px-3 py-2 rounded-lg ${currentConfig.bgLight} ${currentConfig.textColor} hover:opacity-80 transition-opacity`}
            >
                <div className={`w-6 h-6 rounded-full bg-gradient-to-br ${currentConfig.color} flex items-center justify-center`}>
                    <CurrentIcon className="w-3 h-3 text-white" />
                </div>
                <span className="text-sm font-medium hidden sm:block">
                    {currentConfig.label}
                </span>
                <ChevronDown className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
            </button>

            {isOpen && (
                <>
                    <div
                        className="fixed inset-0 z-40"
                        onClick={() => setIsOpen(false)}
                    />
                    <div className="absolute right-0 top-full mt-2 w-56 bg-white dark:bg-gray-800 rounded-xl shadow-xl border border-gray-200 dark:border-gray-700 py-2 z-50 animate-in fade-in slide-in-from-top-2">
                        <div className="px-3 py-2 border-b border-gray-100 dark:border-gray-700">
                            <p className="text-xs text-gray-500 dark:text-gray-400 uppercase font-medium">
                                Trocar Perfil
                            </p>
                        </div>
                        {profiles.map((p) => {
                            const config = roleConfig[p.role as keyof typeof roleConfig] || roleConfig.personal;
                            const Icon = config.icon;
                            const isActive = p.role === activeRole;

                            return (
                                <button
                                    key={p.role}
                                    onClick={() => {
                                        switchRole(p.role as any);
                                        setIsOpen(false);
                                    }}
                                    className={`w-full flex items-center gap-3 px-3 py-2 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors ${isActive ? 'bg-gray-50 dark:bg-gray-700' : ''
                                        }`}
                                >
                                    <div className={`w-8 h-8 rounded-full bg-gradient-to-br ${config.color} flex items-center justify-center`}>
                                        <Icon className="w-4 h-4 text-white" />
                                    </div>
                                    <div className="flex-1 text-left">
                                        <p className="text-sm font-medium text-gray-900 dark:text-white">
                                            {config.label}
                                        </p>
                                        <p className="text-xs text-gray-500 dark:text-gray-400">
                                            {p.email}
                                        </p>
                                    </div>
                                    {isActive && (
                                        <Check className="w-4 h-4 text-green-500" />
                                    )}
                                </button>
                            );
                        })}
                    </div>
                </>
            )}
        </div>
    );
}
